let isProcessingDemoRacquets = false;
let priceUpdatedByScript = false; // Flag to track script updates

// Debug information
// console.log('Demo Racquets Script Initialized');

document.addEventListener('DOMContentLoaded', function () {
  let attempts = 0;
  const maxAttempts = 100;
  
  const waitForRebuy = setInterval(function () {
    attempts++;
    
    if (attempts >= maxAttempts) {
      clearInterval(waitForRebuy);
      // console.warn("Rebuy failed to load after 20 seconds. Demo racquets feature disabled.");
      return;
    }
    
    if (window.Rebuy && window.Rebuy.Cart) {
      
      const rebuyReady = window.Rebuy._status && window.Rebuy._status === "initialized" && window.Rebuy.Cart.status && window.Rebuy.Cart.status === "ready";
      
      if (rebuyReady) {
        clearInterval(waitForRebuy);
        // console.log('✅ Rebuy is ready, starting demo racquets processing');

        processDemoRacquets(window.Rebuy.Cart);

        document.addEventListener('rebuy:cart.change', function (event) {          
          // console.log('rebuy:cart.change event for demo racquets', event.detail);
          if (isProcessingDemoRacquets) {
            return;
          }
          
          setTimeout(() => {
            processDemoRacquets(window.Rebuy.Cart);
          }, 200);
        });
        
        document.addEventListener('rebuy:cart.add', function (event) {          
          // console.log('rebuy:cart.add event for demo racquets', event.detail);
          setTimeout(() => {
            processDemoRacquets(window.Rebuy.Cart);
          }, 200);
        });
        
        document.addEventListener('rebuy:cart.remove', function (event) {          
          // console.log('rebuy:cart.remove event for demo racquets', event.detail);
          setTimeout(() => {
            processDemoRacquets(window.Rebuy.Cart);
          }, 200);
        });
        
        document.addEventListener('rebuy:smartcart.show', function (event) {          
          // console.log('rebuy:smartcart.show event for demo racquets', event.detail);
          setTimeout(() => {
            processDemoRacquets(window.Rebuy.Cart);
          }, 400);
        });
      }
    }
  }, 200);
});

function processDemoRacquets(cart) {
  const TRIGGER_TAG = document.querySelector('.extra-product')?.dataset.triggerProductTag || 'Demo Racquets';
  // console.log('🚀 Starting processDemoRacquets, trigger tag:', TRIGGER_TAG);
  
  if (isProcessingDemoRacquets) {
    // console.log('⏸️ Skipping processDemoRacquets - already processing');
    return;
  }
  
  isProcessingDemoRacquets = true;
  
  const subtotalElement = document.querySelector('.rebuy-cart__flyout-subtotal-amount');
  
  if (!subtotalElement) {
    // console.log('❌ Subtotal element not found');
    isProcessingDemoRacquets = false;
    return;
  }

  const cartDetails = cart.getCart();
  // console.log('Cart details from Rebuy:', cartDetails);

  try {
    // Find demo items by checking product tags (like in extra-product.js)
    // console.log('All cart items:', cartDetails.items.map(item => ({
    //   title: item.product?.title || 'No title',
    //   tags: item.product?.tags || "No tags"
    // })));
    let demoProduct = false;
    let notDemoProduct = false;
    
    const demoItems = cartDetails.items.filter(item => {
      const productTags = item.product?.tags || "";
      const hasTag = productTags.includes(TRIGGER_TAG);
     // console.log(`Item "${item.product?.title || 'Unknown'}" tags: "${productTags}" - has trigger tag: ${hasTag}`);

      const demoFeeAndRacquets = productTags.includes(TRIGGER_TAG) || productTags.includes('demo-fee');
     // console.log('demoFeeAndRacquets =', demoFeeAndRacquets);

      if (demoFeeAndRacquets) {
        demoProduct = true;
      } else {
        notDemoProduct = true;
      }
      return hasTag;
    });
     
    //console.log("demoProduct =", demoProduct);
    //console.log("notDemoProduct =", notDemoProduct);
    const checkoutButton = document.querySelector('.rebuy-cart__checkout-button');
    const cartFooter = document.querySelector('[data-rebuy-cart-anchor="footer"]');
    const notificationDiv = document.querySelector('.extra-product-notification');
    
    if (demoProduct && notDemoProduct) {
      //console.log('🚨 Demo product and not demo product found in cart');
      
      if (checkoutButton) {
        checkoutButton.setAttribute('disabled', 'disabled');
      }
      
      
      if (cartFooter && notificationDiv) {
      
        let footerNotification = cartFooter.querySelector('.extra-product-notification');
        if (!footerNotification) {
          footerNotification = notificationDiv.cloneNode(true);
          footerNotification.style.display = 'block';
          cartFooter.insertBefore(footerNotification, cartFooter.firstChild);
        }
        footerNotification.style.display = 'block';
      }
    } else {
     // console.log('✅ No demo product and not demo product found in cart');
      
      if (checkoutButton) {
        checkoutButton.removeAttribute('disabled');
      }
      
      // Удаляем уведомление из футера корзины
      if (cartFooter) {
        const footerNotification = cartFooter.querySelector('.extra-product-notification');
        if (footerNotification) {
          footerNotification.remove();
        }
      }
    }
    // console.log(`Found ${demoItems.length} demo items in cart:`, demoItems.map(item => item.product?.title));
    
    // Calculate total cost of demo items
    const demoTotalCents = demoItems.reduce((total, item) => {
      const itemPrice = item.final_line_price || item.line_price || (item.price * item.quantity) || 0;
      return total + itemPrice;
    }, 0);
    
    const demoTotalDollars = demoTotalCents / 100;
    const originalTotalDollars = cartDetails.total_price / 100;
    
    // console.log('Demo Racquets Processing:', {
    //   totalItems: cartDetails.items.length,
    //   demoItemsCount: demoItems.length,
    //   originalTotal: originalTotalDollars,
    //   demoTotal: demoTotalDollars,
    //   triggerTag: TRIGGER_TAG
    // });
    
    // Save original price
    let originalPrice = parseFloat(subtotalElement.getAttribute('data-original-price'));
    if (!originalPrice) {
      originalPrice = originalTotalDollars;
      subtotalElement.setAttribute('data-original-price', originalPrice.toString());
    }
    
    if (demoTotalDollars > 0) {
      // Calculate adjustment
      const adjustedSubtotal = Math.max(0, originalTotalDollars - demoTotalDollars);
      
      // Update display with flag
      priceUpdatedByScript = true;
      const formattedPrice = adjustedSubtotal > 0 ? '$' + adjustedSubtotal.toFixed(2) : '$0.00';
      subtotalElement.textContent = formattedPrice;
      
      subtotalElement.setAttribute('data-demo-adjusted', 'true');
      subtotalElement.setAttribute('data-demo-total', demoTotalDollars.toString());
      
      // console.log('Demo racquets adjustment (Rebuy-based):', {
      //   originalTotal: originalTotalDollars,
      //   demoTotal: demoTotalDollars,
      //   adjustedSubtotal: adjustedSubtotal,
      //   formattedPrice: formattedPrice
      // });
      
      // Start aggressive price protection
      startPriceWatcher(adjustedSubtotal);
      
    } else {
      // No demo items, show original price
      stopPriceWatcher();
      
      priceUpdatedByScript = true;
      const formattedPrice = '$' + originalTotalDollars.toFixed(2);
      subtotalElement.textContent = formattedPrice;
      
      subtotalElement.removeAttribute('data-demo-adjusted');
      subtotalElement.removeAttribute('data-demo-total');
      
      // console.log('No demo items found, showing original total:', originalTotalDollars);
    }
    
    // Reset flag after short time
    setTimeout(() => {
      priceUpdatedByScript = false;
    }, 100);
    
  } catch (error) {
    console.error("Error processing demo racquets:", error);
    isProcessingDemoRacquets = false;
  }
  
  isProcessingDemoRacquets = false;
  // console.log('✅ Finished processDemoRacquets');
}

// Aggressive protection from Rebuy - track price changes
let priceWatcher = null;
let expectedPrice = 0;

function startPriceWatcher(targetPrice) {
  if (priceWatcher) clearInterval(priceWatcher);
  
  expectedPrice = targetPrice;
  
  priceWatcher = setInterval(() => {
    const subtotalElement = document.querySelector('.rebuy-cart__flyout-subtotal-amount');
    
    if (!subtotalElement) return;
    
    const currentText = subtotalElement.textContent.replace(/[^0-9.,]/g, '');
    const currentPrice = parseFloat(currentText.replace(',', '.'));
    
    // If price differs from expected by more than 1 cent
    if (Math.abs(currentPrice - expectedPrice) > 0.01) {
      priceUpdatedByScript = true;
      const formattedPrice = expectedPrice > 0 ? '$' + expectedPrice.toFixed(2) : '$0.00';
      subtotalElement.textContent = formattedPrice;
      // console.log('Price watcher: Corrected price from', currentPrice, 'to', expectedPrice);
      
      setTimeout(() => {
        priceUpdatedByScript = false;
      }, 100);
    }
  }, 500);
}

function stopPriceWatcher() {
  if (priceWatcher) {
    clearInterval(priceWatcher);
    priceWatcher = null;
  }
} 